import { SET_CONFIGURATION } from '@/store/mutation-types'
import dashboard from './dashboard'
import layout from './layout'
import search from './search'
import consignmentTable from './tables/consignment'

const getters = {
  configuration: (state) => state
}

const mutations = {
  [SET_CONFIGURATION] (state, data) {
    Object.assign(state, data)
  }
}

const modules = {
  dashboard,
  layout,
  search,
  consignmentTable
}

export default {
  namespaced: true,
  getters,
  mutations,
  modules
}
